import arriereBackoffice from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { getBookingHomeInfo } from '@arriere/modules/bookings'

export const getModifyBookingInfo = async (bookingId?: string) => {
  if (bookingId === undefined) return undefined

  const { data, errors } = await arriereBackoffice.queries.booking.raw({
    __alias: 'getModifyBookingInfo',
    __args: { bookingId },
    id: true,
    hash: true,
    homeId: true,
    source: true,
    guests: true,
    isRoomAssigned: true,
    period: {
      start: true,
      end: true,
    },
    detailedCheckIn: {
      effectiveTime: true,
    },
    detailedCheckOut: {
      effectiveTime: true,
    },
    hotel: {
      id: true,
    },
    hotelRoomType: {
      id: true,
      hotelId: true,
      roomKind: true,
    },
    customFields: {
      __args: { tags: [] },
      fields: {
        id: true,
        value: true,
      },
    },
    otaBookingInfo: {
      channel: true,
    },
  })

  if (errors?.length) {
    throw new Error(errors[errors.length - 1]?.message)
  }

  const home = await getBookingHomeInfo({ bookingId })

  return { ...data, home }
}
